<template>
  <el-drawer
    ref="drawer"
    title="上年度结转数据确认"
    :before-close="handleClose"
    :visible.sync="dialog"
    custom-class="demo-drawer"
    :wrapper-closable="false"
  >
    <div class="demo-drawer__content">
      <el-form ref="form" :model="form" label-position="left" :disabled="disabled" :rules="rules">
        <el-form-item label="贷款余额:" :label-width="formLabelWidth" prop="loan_amount">
          <el-input v-model="form.loan_amount" type="number" autocomplete="off">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="逾期余额:" :label-width="formLabelWidth" prop="overdue_loan_amount">
          <el-input v-model="form.overdue_loan_amount" type="number" autocomplete="off">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="!disabled" label="修改说明:" :label-width="formLabelWidth" prop="remark">
          <el-input
            v-model="form.remark" type="textarea"
            placeholder="请输入内容"
            maxlength="200"
            :rows="4"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="toggleEditable">{{ disabled ? '修 改' : '取消修改' }}</el-button>
        <el-button type="primary" :loading="loading" @click="handleConfirmAmount">
          {{
            loading ? '确认中 ...' : '确 认'
          }}
        </el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import axios from 'axios'

export default {
  name: 'LoanAmountConfirm',
  props: {
    company: {
      type: Object,
    },
  },
  data() {
    var validateAmount = (rule, value, callback) => {
      var regex = new RegExp('^\\d*(\\.\\d{0,2})?$', 'g')
      if (!regex.test(value)) {
        callback(new Error('请输入正确的余额金额,最多到小数点后两位'))
      } else {
        callback()

      }
    }
    return {
      dialog: this.company.amount_confirmed === 0,
      loading: false,
      disabled: true,
      form: {
        loan_amount: this.company.init_loan_amount,
        overdue_loan_amount: this.company.init_overdue_loan_amount,
        remark: ''
      },
      rules: {
        loan_amount: [{required: true, message: '请输入上年度结转数据贷款余额', trigger: 'blur'}, {validator: validateAmount, trigger: 'blur' }],
        overdue_loan_amount: [{required: true, message: '请输入上年度结转数据逾期余额', trigger: 'blur'}, {validator: validateAmount, trigger: 'blur' }],
        remark: [{required: true, message: '请输入修改说明', trigger: 'blur'}]
      },
      formLabelWidth: '150px',
      timer: null,
    }
  },
  methods: {
    handleClose(done) {
      this.$confirm('上年度结转数据需要您手动点击确认按钮后确认，确定要退出吗？', '', {type: 'warning'})
        .then(_ => {
          this.dialog = false
          done()
        })
        .catch(_ => {
        })
    },
    handleConfirmAmount() {
      this.$refs.form.validate(validate => {
        if (validate) {
          this.$confirm(`确认公司上年度结转数据贷款余额${this.form.loan_amount}元，逾期余额${this.form.overdue_loan_amount}元？如需再次更改请联系上级主管部门`, '', {type: 'warning'})
            .then(_ => {
              this.loading = true
              axios.post('/amount/confirm', this.form).then(res => {
                this.loading = false
                if (res.data.status !== 1) {
                  this.$message.error(res.data.message)
                } else {
                  this.$message.success('确认成功, 如需再次更改请联系上级主管部门')
                  this.dialog = false
                }
              }).catch(err => {
                this.loading = false

              })
            })
            .catch(_ => {
            })
        }
      })

    },
    toggleEditable() {
      this.disabled = !this.disabled
      if (this.disabled) {
        this.form = {
          loan_amount: this.company.init_loan_amount,
          overdue_loan_amount: this.company.init_overdue_loan_amount,
        }
      }
      this.$refs.form.clearValidate()
    },
  },
}
</script>

<style lang="scss" scoped>

.demo-drawer {
  &__content {
    display: flex;
    flex-direction: column;
    height: 100%;

    form {
      flex: 1;
    }
  }

  &__footer {
    display: flex;

    button {
      flex: 1;
    }
  }

}

::v-deep .el-drawer__body {
  padding: 20px;
}
</style>
